import React from 'react';
import classnames from 'classnames'

const CommonPagerSelect = ({label,require,data,value,onChange,name}) => {
    return (
        <div className="form-group col-md-6">
            <label htmlFor="inputEmail4">{label} {require && <span className="text-danger">*</span>}</label>
        <nav aria-label="Page navigation text-center">
            <ul className="pagination  pager-selection">
                {data.map((d, index) => <li key={index}
                                                  className={classnames('page-item', {
                                                      'active': value === d
                                                  })}
                ><span
                    className={"page-link"}
                    onClick={() => onChange(name, d)}>{d}</span></li>)}
            </ul>
        </nav>
        </div>
    );
};

export default CommonPagerSelect;